import { Controller, useFormContext } from 'react-hook-form';
import Select, { SelectProps } from 'src/components/ui/Select';

interface FormSelectProps extends Omit<
  SelectProps<object>,
  'name' | 'isInvalid' | 'errorMessage' | 'validationBehavior' | 'data-rhf-name'
> {
  name: string;
}

const FormSelect = ({ name, ...rest }: FormSelectProps) => {
  const { control, clearErrors } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { invalid, error } }) => (
        <Select
          {...field}
          {...rest}
          data-rhf-name={name}
          selectedKey={field.value}
          onSelectionChange={(selected) => {
            clearErrors(name);
            field.onChange(selected?.toString() ?? '');
          }}
          validationBehavior="aria"
          isInvalid={invalid}
          errorMessage={error?.message}
        />
      )}
    />
  );
};

export default FormSelect;
